import React from 'react';
import PropTypes from 'prop-types';

import { EditSwitch, EnableSectionUpsell, EditArrowSection } from './MainContent';
import Segmentation from './Segmentation';
import Event from '../../models/Event';
import { CREATOR_REPORTS_SEGMENTATION } from '../../constants';

const SegmentationSection = ({ event, segmentation, editing, sections, isSegmentationVisuallyEnabled, isSegmentationEnabled, isPdfRender, handleSegmentationSwitchChanged, handleSegmentationEditClicked, handleOnSectionsSet, index }) => {
  return (isSegmentationEnabled || (editing && Event.isSentimentEnabled(event))) && (
    <div className="report-card-wrapper col page-break-avoid">
      <div className="row no-gutters">
        <div className={`report-wrapper col${editing ? '-11' : ''}`}>
          <div className={`report-card ${!editing ? 'report-border' : ''}`}>
            {editing && (
              <div className="editing">
                <EditSwitch
                  id={CREATOR_REPORTS_SEGMENTATION}
                  checked={isSegmentationVisuallyEnabled}
                  onChange={handleSegmentationSwitchChanged}
                />
              </div>
            )}
            <div
              className={`card-title text-truncate ${editing && 'editing-title'}`}>
              SEGMENTATION
            </div>

            { /* Don't need to check question type because container checks */ }
            {((isSegmentationEnabled && !editing) ||
              (editing && isSegmentationVisuallyEnabled)
            ) ? <Segmentation
                onEditClicked={handleSegmentationEditClicked}
                event={event}
                editing={editing}
                isPdfRender={isPdfRender}
                segmentation={segmentation} />
              : editing
                ? (
                  <EnableSectionUpsell
                    content={
                      (segmentation && segmentation.length > 0)
                        ? 'Show results filtered by subgroups in the report.'
                        : 'Enabling this allows you to segment your results by subgroups.'
                    } />
                )
                : null
            }
          </div>
        </div>
        <EditArrowSection
          name="segmentation"
          sections={sections}
          onSectionsSet={handleOnSectionsSet}
          editing={editing}
          index={index} />
      </div>
    </div>
  );
};

SegmentationSection.propTypes = {
  event: PropTypes.object.isRequired,
  segmentation: PropTypes.array.isRequired,
  editing: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  isSegmentationVisuallyEnabled: PropTypes.bool.isRequired,
  isSegmentationEnabled: PropTypes.bool.isRequired,
  isPdfRender: PropTypes.bool,
  handleSegmentationSwitchChanged: PropTypes.func.isRequired,
  handleSegmentationEditClicked: PropTypes.func.isRequired,
  handleOnSectionsSet: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default SegmentationSection;
